module.exports = __webpack_public_path__ + "img/uchile.c96d385a.png";